import sanitizeHTML from "sanitize-html";
import styled from "styled-components";

export const StyledHTMLContentDiv = styled.div`
  blockquote {
    overflow: hidden;
    padding-right: 1.5em;
    padding-left: 1.5em;
    margin-left: 0;
    margin-right: 0;
    font-style: italic;
    border-left: 5px solid #ccc;
  }
  blockquote[dir="rtl"] {
    border-right: 5px solid #ccc;
  }
  ul,
  ol {
    padding-left: 1rem;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
  }
  ol {
    list-style: decimal;
  }
  ul {
    list-style: disc;
  }
`;

type RenderHTMLContentProps = {
  html: string;
  className?: string;
};

export function RenderHTMLContent({
  html,
  className,
  ...props
}: RenderHTMLContentProps) {
  return (
    <StyledHTMLContentDiv
      className={className}
      dangerouslySetInnerHTML={{
        __html: sanitizeHTML(html),
      }}
      {...props}
    />
  );
}
